import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "../../css/Dashboard.module.css";

const ViewStudents = () => {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("default");

  useEffect(() => {
    fetchStudents();
  }, []);

  useEffect(() => {
    filterAndSortStudents();
  }, [students, searchTerm, sortOption]);

  const fetchStudents = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        setError("You need to be logged in to view students.");
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `https://techservicemarket-backend.onrender.com/api/university/students`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setStudents(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching students:", error);
      setError("Failed to fetch students. Please try again later.");
      setLoading(false);
    }
  };

  const filterAndSortStudents = () => {
    let filtered = [...students];

    if (searchTerm) {
      filtered = filtered.filter((student) =>
        student.skills.some((skill) =>
          skill.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    if (sortOption === "skillsAsc") {
      filtered.sort((a, b) => a.skills.length - b.skills.length);
    } else if (sortOption === "skillsDesc") {
      filtered.sort((a, b) => b.skills.length - a.skills.length);
    }

    setFilteredStudents(filtered);
  };

  return (
    <div className={styles.dashboardContainer}>
      <h1 className={styles.dashboardHeader}>View Students</h1>
      {loading && <p>Loading students...</p>}
      {!loading && error && <p className={styles.errorText}>{error}</p>}

      {/* Search and Sort Controls */}
      <div className={styles.searchSection}>
        <input
          type="text"
          placeholder="Search by skill..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />
        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          className={styles.selectInput}
        >
          <option value="default">Sort by</option>
          <option value="skillsAsc">Skills (Low to High)</option>
          <option value="skillsDesc">Skills (High to Low)</option>
        </select>
      </div>

      {/* Student Cards */}
      <div className={styles.jobListSection}>
        {filteredStudents.length > 0 ? (
          filteredStudents.map((student) => (
            <div key={student._id} className={styles.jobCard}>
              <p>
                <strong>Username:</strong> {student.username}
              </p>
              <p>
                <strong>Name:</strong> {student.firstName} {student.lastName}
              </p>
              <p>
                <strong>Email:</strong> {student.email}
              </p>
              <div>
                <strong>Skills:</strong>
                {student.skills.length > 0 ? (
                  <ul>
                    {student.skills.map((skill, index) => (
                      <li key={index}>{skill}</li>
                    ))}
                  </ul>
                ) : (
                  <p>No skills available</p>
                )}
              </div>
            </div>
          ))
        ) : (
          <p>No students found.</p>
        )}
      </div>
    </div>
  );
};

export default ViewStudents;
